var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { AbFeatures } from './../../common/utils/abFeature';
import moment from "moment";
import { observable, computed, action, reaction, runInAction } from "mobx";
import http, { Q, Api } from "@http";
import { isArray, max, take } from "lodash-es";
import Cookies from "js-cookie";
import { ClientUserTrackingCode, ScheduleEntryType, ScheduleType } from "@common/enums/base";
import { extractTimeOfSlotFn, getTimeOfSlotRank, getIsRecommendationSlot } from "@common/utils";
import { cookie } from '@common/utils/storage';
var ProjectProcareStatus = {
    Completed: 4,
    Canceled: 5,
    Scheduled: 8,
    Unscheduled: 20
};
var ProcareStore = /** @class */ (function () {
    function ProcareStore() {
        var _this = this;
        this.fetchingState = {
            getProCareDetail: false,
            getCanChangeTechnician: false,
            getScheduleTime: false,
            getWeather: false,
            firstLoadComplete: false,
            loadingScheduleTime: false,
            saving: false,
            getProjectWorkOrderList: false
        };
        this.formData = {
            scheduleStartTime: null,
            scheduleEndTime: null
        };
        this.changeScheduleStartTime = function (value) {
            _this.formData.scheduleStartTime = value;
        };
        this.changeScheduleEndTime = function (value) {
            _this.formData.scheduleEndTime = value;
        };
        this.procareDetail = {
            DueDate: "",
            Id: "",
            Location: { Id: "" },
            StatusId: 0,
            ProjectTypeId: 0,
            Version: "",
            LocationId: "",
            Client: { Id: "" },
            ScheduleStart: "",
            ScheduleEnd: ""
        };
        this.canChangeTechnician = false;
        this.hasProcareProject = false;
        this.getProCareDetail = function () { return __awaiter(_this, void 0, void 0, function () {
            var detail;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fetchingState.getProCareDetail = false;
                        return [4 /*yield*/, this.api.rspGetProcareProject()];
                    case 1:
                        detail = _a.sent();
                        runInAction(function () {
                            _this.procareDetail = detail;
                            _this.fetchingState.getProCareDetail = true;
                            _this.workOrderList.length = 0;
                            if (_this.procareDetail) {
                                _this.getCanChangeTechnician();
                                _this.getProjectWorkOrderList();
                                _this.hasProcareProject = true;
                            }
                            else {
                                _this.fetchingState.getProjectWorkOrderList = true;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.currentPage = 1;
        this.workOrderList = [];
        this.totalCount = 0;
        this.isAllWorkOrderListReady = false;
        this.allWorkOrderList = [];
        this.scheduleTime = [];
        this.isLastVersionAutoSchedule = undefined;
        this.scheduleTrackData = [];
        this.weatherForecastByTime = [];
        this.selectPeroid = function (data) {
            _this.selectedScheduleTime = data;
        };
        this.modalVisible = false;
        this.setModalVisible = function (visible) {
            _this.modalVisible = visible;
        };
        this.saveSchedule = function () {
            if (!_this.canSave) {
                return new Promise(function () { });
            }
            runInAction(function () {
                _this.fetchingState.saving = true;
            });
            if (_this.isLastVersionAutoSchedule) {
                return _this.saveWithLastVersion();
            }
            return _this.saveWithOldVersion();
        };
        this.clickTaskCancel = function (projectTaskId) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.updateSubtaskStatus(projectTaskId)];
                    case 1:
                        _a.sent();
                        runInAction(function () {
                            _this.currentPage = 1;
                            _this.workOrderList.length = 0;
                            _this.getProjectWorkOrderList();
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.recordEscalateInfoToCookies = function (subtaskObj) {
            Cookies.set("additionalDetailRequst", subtaskObj.AdditionalDetail, { path: "/" });
            Cookies.set("proCareProjectId", _this.procareDetail.Id, { path: "/" });
            Cookies.set("proCareTaskId", subtaskObj.ProjectTaskId, { path: "/" });
            if (!!subtaskObj.WoNum) {
                Cookies.set("proCareSubtaskWoNum", subtaskObj.WoNum, { path: "/" });
            }
        };
        this.pageMore = function () { return __awaiter(_this, void 0, void 0, function () {
            var query, moreData;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.currentPage += 1;
                        query = { ProjectId: (_a = this.procareDetail) === null || _a === void 0 ? void 0 : _a.Id, PageSize: 10, Page: this.currentPage };
                        return [4 /*yield*/, this.api.projectWoList(query)];
                    case 1:
                        moreData = _b.sent();
                        runInAction(function () {
                            _this.workOrderList = _this.workOrderList.concat(moreData.Items);
                            _this.totalCount = moreData.TotalItemsCount;
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.getAllSubtask = function () { return __awaiter(_this, void 0, void 0, function () {
            var MAX_PAGE_SIZE, query, allSubtask;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        MAX_PAGE_SIZE = 100;
                        query = { ProjectId: (_a = this.procareDetail) === null || _a === void 0 ? void 0 : _a.Id, PageSize: MAX_PAGE_SIZE };
                        return [4 /*yield*/, this.api.projectWoList(query)];
                    case 1:
                        allSubtask = _b.sent();
                        runInAction(function () {
                            _this.allWorkOrderList = allSubtask.Items;
                            _this.isAllWorkOrderListReady = true;
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.scheduleRecommendTrack = function () {
            if (_this.showReschedule)
                return;
            _this.api.scheduleRecommendTrack({
                refId: _this.procareDetail.Id,
                trackOption: _this.selectedScheduleTime,
                trackData: _this.scheduleTrackData,
                refType: ScheduleType.ProCare,
                scheduleEntryType: ScheduleEntryType.ProcareSchedule
            });
        };
        this.onLeave = function () {
            _this.totalCount = 0;
            _this.workOrderList.length = 0;
            _this.modalVisible = false;
        };
        this.api = {
            rspScheduleGetScheduleTimeWithLastVersion: function (formData) {
                return Q(http.post("/VisitAutoSchedule/GetProCareRecommendTechnicians", formData, Api.withForm));
            },
            rspRescheduleGetScheduleTimeWithLastVersion: function (formData) {
                return Q(http.post("/VisitAutoSchedule/GetRescheduleProCareRecommendTechnicians", formData, Api.withForm));
            },
            rspGetWeatherForecastByTime: function (formData) {
                return Q(http.post("/RSP/NewRequest/GetWeatherForecastByTime", formData, Api.withForm));
            },
            canChangeTechnician: function (procareId) {
                return Q(http.get("/RSP/ProCare/" + procareId + "/CanChangeTechnician"));
            },
            rspGetProcareProject: function () {
                return Q(http.get("/RSP/ProCare/GetProcareProject"));
            },
            updateProCareWO: function (procareId, data) {
                return Q(http.post("/RSP/ProCare/UpdateProCareWO", data));
            },
            projectWoList: function (query) {
                return Q(http.post("/RSP/ProCare/GetProjectWorkOrderList", query));
            },
            updateSubtaskStatus: function (projectTaskId) {
                return Q(http.post("/RSP/ProCare/UpdateSubtaskStatus", { taskId: projectTaskId }));
            },
            hasVisitAndScheduleCalendarAbmodule: function (locationId) {
                return Q(http.post("/abmodule/hasabmodulepermissionByLocation", {
                    locationId: locationId,
                    abmodule: AbFeatures.VisitDrivenAndScheduleCalendar
                }));
            },
            scheduleRecommendTrack: function (params) {
                return Q(http.post("/Track/schedule", params));
            }
        };
        this.initReactions();
    }
    ProcareStore.prototype.initReactions = function () {
        var _this = this;
        var reactionFn = function () { return ({
            ready: _this.fetchingState.getProCareDetail &&
                _this.fetchingState.getCanChangeTechnician &&
                _this.formData.scheduleStartTime &&
                _this.canChangeTechnician &&
                (_this.showReschedule || _this.showSchedule) &&
                _this.modalVisible,
            scheduleStartTime: _this.formData.scheduleStartTime
        }); };
        var callback = function (result) {
            var ready = result.ready, scheduleStartTime = result.scheduleStartTime;
            if (ready) {
                _this.selectedScheduleTime = null;
                _this.getScheduleTime(scheduleStartTime);
            }
        };
        reaction(reactionFn, callback, { delay: 30 });
    };
    Object.defineProperty(ProcareStore.prototype, "procareDueDate", {
        get: function () {
            if (this.procareDetail) {
                return moment(this.procareDetail.DueDate)
                    .utc()
                    .format("MM/DD/YYYY");
            }
            return "";
        },
        enumerable: false,
        configurable: true
    });
    ProcareStore.prototype.getDueRange = function (rangeLeftOrRight) {
        // 24h * 60min * 60s * 30d * 1000ms * 2month
        var left60DaysOffset = -5184000000;
        // 24h * 60min * 60s * 30d * 1000ms  
        var right30DaysOffset = 2592000000;
        // getTimezoneOffset * 60s * 1000ms
        var offset = rangeLeftOrRight ? left60DaysOffset : right30DaysOffset;
        var timeStampOffset = new Date().getTimezoneOffset() * 60000 + offset;
        return moment(moment(this.procareDetail.DueDate).valueOf() + timeStampOffset);
    };
    Object.defineProperty(ProcareStore.prototype, "dueRangeLeft", {
        get: function () {
            var rangeLeft = true;
            return this.procareDetail ? this.getDueRange(rangeLeft) : moment();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProcareStore.prototype, "dueRangeRight", {
        get: function () {
            var rangeRight = false;
            return this.procareDetail ? this.getDueRange(rangeRight) : moment();
        },
        enumerable: false,
        configurable: true
    });
    ProcareStore.prototype.getProjectWorkOrderList = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var query, listRes;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.fetchingState.getProjectWorkOrderList = false;
                        this.currentPage = 1;
                        query = { ProjectId: (_a = this.procareDetail) === null || _a === void 0 ? void 0 : _a.Id, PageSize: 10, Page: this.currentPage };
                        return [4 /*yield*/, this.api.projectWoList(query)];
                    case 1:
                        listRes = _b.sent();
                        runInAction(function () {
                            _this.fetchingState.getProjectWorkOrderList = true;
                            _this.workOrderList = listRes.Items;
                            _this.totalCount = listRes.TotalItemsCount;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ProcareStore.prototype.getCanChangeTechnician = function () {
        return __awaiter(this, void 0, void 0, function () {
            var canData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fetchingState.getCanChangeTechnician = false;
                        return [4 /*yield*/, this.api.canChangeTechnician(this.procareDetail.Id)];
                    case 1:
                        canData = _a.sent();
                        runInAction(function () {
                            _this.canChangeTechnician = canData;
                            _this.fetchingState.getCanChangeTechnician = true;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ProcareStore.prototype, "noScheduleTime", {
        get: function () {
            return (this.fetchingState.firstLoadComplete &&
                (this.topItems.length === 0 || this.topItems.every(function (time) { return !time.canSelect; })));
        },
        enumerable: false,
        configurable: true
    });
    ProcareStore.prototype.getScheduleTime = function (scheduleStartTime) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_c) {
                if (!this.fetchingState.getWeather) {
                    this.getWeatherForecastByTime();
                }
                this.fetchingState.getScheduleTime = false;
                this.fetchingState.loadingScheduleTime = true;
                formData = {
                    woClientId: Cookies.get("clientId"),
                    locationId: this.procareDetail.Location.Id,
                    projectId: (_a = this.procareDetail) === null || _a === void 0 ? void 0 : _a.Id,
                    procareId: (_b = this.procareDetail) === null || _b === void 0 ? void 0 : _b.Id,
                    reschedule: this.showReschedule,
                    startTime: moment(scheduleStartTime).format("YYYY-MM-DD HH:mm:ss"),
                    canScheduleInWeekend: false,
                };
                if (this.isLastVersionAutoSchedule) {
                    this.getAutoScheduleDataWithLastVersion(formData);
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    ProcareStore.prototype.getisLastVersionAutoSchedule = function () {
        var _this = this;
        var locationId = cookie("locationId");
        if (!locationId)
            return;
        this.api.hasVisitAndScheduleCalendarAbmodule(locationId).then(function (hasVisitAndScheduleCalendarAbmodule) {
            runInAction(function () {
                _this.isLastVersionAutoSchedule = hasVisitAndScheduleCalendarAbmodule;
            });
        });
    };
    ProcareStore.prototype.getAutoScheduleData = function (formData) {
        if (this.isLastVersionAutoSchedule) {
            this.getAutoScheduleDataWithLastVersion(formData);
        }
        return;
    };
    ProcareStore.prototype.getAutoScheduleDataWithLastVersion = function (formData) {
        return __awaiter(this, void 0, void 0, function () {
            var scheduleTimeData, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.showReschedule) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.api.rspRescheduleGetScheduleTimeWithLastVersion(formData)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.api.rspScheduleGetScheduleTimeWithLastVersion(formData)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        scheduleTimeData = _a;
                        runInAction(function () {
                            _this.fetchingState.firstLoadComplete = true;
                            _this.fetchingState.getScheduleTime = true;
                            _this.fetchingState.loadingScheduleTime = false;
                            if (!scheduleTimeData) {
                                _this.scheduleTime = [];
                            }
                            else {
                                var _a = scheduleTimeData.pullInRecommend, pullInRecommend = _a === void 0 ? {} : _a;
                                _this.scheduleTime = _this.formartRawAutoScheduleWithLastVersion(scheduleTimeData);
                                _this.scheduleTrackData = pullInRecommend.trackData;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ProcareStore.prototype.formartRawAutoScheduleWithLastVersion = function (rawData) {
        if (!(rawData && rawData.pullInRecommend)) {
            return [];
        }
        var pullInRecommend = rawData.pullInRecommend;
        pullInRecommend.topRecommends.forEach(function (x) { x.isRecommend = true; });
        pullInRecommend.recommends.forEach(function (x) { x.isRecommend = false; });
        var scheduleTimeList = __spreadArrays(pullInRecommend.topRecommends, pullInRecommend.recommends);
        return scheduleTimeList.map(function (x) {
            return {
                id: Symbol(),
                scheduleStartTime: x.scheduleStartTime,
                scheduleEndTime: x.scheduleEndTime,
                canSelect: x.canSelect,
                isRecommend: x.isRecommend,
                _rank: x.indexOf,
                BundleWoIds: null,
                technicianId: null,
                _sumArr: null,
                _weather: null,
                _selected: false,
                affiliateId: x.affiliateId,
                technicianScores: x.technicianScores,
                visitId: x.visitId
            };
        });
    };
    ProcareStore.prototype.formartRawAutoSchedule = function (rawData) {
        var items = rawData;
        items.forEach(function (element) {
            element._sumArr = element.sum.split(",").map(function (sum) { return parseFloat(sum); });
            element._maxSum = max(element._sumArr);
        });
        items.sort(function (a, b) {
            if (b._maxSum === a._maxSum) {
                return (moment(a.schedulestarttime)
                    .toDate()
                    .getTime() -
                    moment(b.schedulestarttime)
                        .toDate()
                        .getTime());
            }
            return b._maxSum - a._maxSum;
        });
        return items.map(function (x, index) {
            return {
                id: x._symbol,
                scheduleStartTime: x.schedulestarttime,
                scheduleEndTime: x.scheduleendtime,
                canSelect: x._maxSum > 0,
                isRecommend: x._maxSum > 0 && index < 3,
                _rank: index + 1,
                BundleWoIds: x.BundleWoIds,
                technicianId: x.technicianId,
                _sumArr: x._sumArr
            };
        });
    };
    ProcareStore.prototype.getWeatherForecastByTime = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formData, i, weatherData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fetchingState.getWeather = false;
                        formData = {
                            locationId: this.procareDetail.Location.Id,
                            times: []
                        };
                        for (i = -1; i < 16; i += 1) {
                            formData.times.push(moment().utc()
                                .add(i, "days")
                                .format("YYYY-MM-DD"));
                        }
                        return [4 /*yield*/, this.api.rspGetWeatherForecastByTime(formData)];
                    case 1:
                        weatherData = _a.sent();
                        runInAction(function () {
                            _this.fetchingState.getWeather = true;
                            if (isArray(weatherData)) {
                                _this.weatherForecastByTime = weatherData;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ProcareStore.prototype, "topItems", {
        get: function () {
            var _this = this;
            var items = this.scheduleTime;
            items.forEach(function (element) {
                var dateStr = _this.getYYMMDD(moment(element.scheduleStartTime));
                var weather = _this.weatherForecastByTime.find(function (weather) {
                    var weatherDateStr = _this.getYYMMDD(moment(weather.date));
                    return weatherDateStr === dateStr;
                });
                element._weather = weather;
                element._selected = _this.selectedScheduleTime && element.id === _this.selectedScheduleTime.id;
            });
            return take(items, 7);
        },
        enumerable: false,
        configurable: true
    });
    ProcareStore.prototype.getYYMMDD = function (momentObj) {
        return momentObj.utc().format("YYYY-MM-DD");
    };
    Object.defineProperty(ProcareStore.prototype, "showReschedule", {
        get: function () {
            return this.procareDetail ? this.procareDetail.StatusId === ProjectProcareStatus.Scheduled : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProcareStore.prototype, "showSchedule", {
        get: function () {
            var _this = this;
            var showGroup = [ProjectProcareStatus.Unscheduled];
            return this.procareDetail ? showGroup.some(function (id) { return id === _this.procareDetail.StatusId; }) : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProcareStore.prototype, "canSave", {
        get: function () {
            return this.selectedScheduleTime !== null;
        },
        enumerable: false,
        configurable: true
    });
    ProcareStore.prototype.saveWithLastVersion = function () {
        var _a;
        var selectedScheduleTime = this.selectedScheduleTime;
        var autoScheduleModel = {
            projectId: (_a = this.procareDetail) === null || _a === void 0 ? void 0 : _a.Id,
            scheduleStartTime: selectedScheduleTime.scheduleStartTime,
            scheduleEndTime: selectedScheduleTime.scheduleEndTime,
            affiliateId: selectedScheduleTime.affiliateId,
            technicianScores: selectedScheduleTime.technicianScores,
            visitId: selectedScheduleTime.visitId,
            rank: selectedScheduleTime._rank,
        };
        console.log(selectedScheduleTime);
        var timeOfSlotRank = getTimeOfSlotRank([selectedScheduleTime]);
        var isRecommendationSlot = getIsRecommendationSlot([selectedScheduleTime]);
        return this.sendUpdateProCareApi(autoScheduleModel, timeOfSlotRank, isRecommendationSlot);
    };
    ProcareStore.prototype.saveWithOldVersion = function () {
        var _this = this;
        var _a;
        var techIds = this.selectedScheduleTime.technicianId.split(",");
        var ScheduleV32 = techIds.map(function (techId, index) {
            return {
                TechnicianIds: techId,
                ScheduleStartTime: _this.selectedScheduleTime.scheduleStartTime,
                ScheduleEndTime: _this.selectedScheduleTime.scheduleEndTime,
                Scores: _this.selectedScheduleTime._sumArr[index]
            };
        });
        var bundleWoIds = this.selectedScheduleTime.BundleWoIds.toJS();
        var breakupModel = {};
        if (!!this.procareDetail.Id) {
            breakupModel = {
                projectId: (_a = this.procareDetail) === null || _a === void 0 ? void 0 : _a.Id,
                scheduleStartTime: this.selectedScheduleTime.scheduleStartTime,
                scheduleEndTime: this.selectedScheduleTime.scheduleEndTime
            };
        }
        var noScheduleTime = __assign({ ScheduleV32: ScheduleV32 }, breakupModel);
        var hasScheduleTime = {
            ScheduleV32: ScheduleV32,
            bundleWoIds: bundleWoIds,
            projectId: this.procareDetail.Id,
            scheduleStartTime: this.selectedScheduleTime.scheduleStartTime,
            scheduleEndTime: this.selectedScheduleTime.scheduleEndTime
        };
        var autoscheduleModel = bundleWoIds.length === 0 ? noScheduleTime : hasScheduleTime;
        var _b = extractTimeOfSlotFn([this.selectedScheduleTime]), extractTimeOfSlot = _b.extractTimeOfSlot, isRecommendationSlot = _b.isRecommendationSlot;
        return this.sendUpdateProCareApi(autoscheduleModel, extractTimeOfSlot.join(','), isRecommendationSlot);
    };
    ProcareStore.prototype.sendUpdateProCareApi = function (autoscheduleModel, timeofSlotRank, isRecommendationSlot) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var _a, LocationId, Id, Client, StatusId, logData, code;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.api.updateProCareWO(this.procareDetail.Id, {
                            autoscheduleModel: autoscheduleModel,
                            procareId: this.procareDetail.Id,
                            projectTypeId: this.procareDetail.ProjectTypeId,
                            version: this.procareDetail.Version,
                            locationId: this.procareDetail.Location.Id,
                            scheduleStartTime: this.selectedScheduleTime.scheduleStartTime,
                            scheduleEndTime: this.selectedScheduleTime.scheduleEndTime,
                            isReschedule: this.showReschedule
                        })];
                    case 1:
                        _b.sent();
                        this.setModalVisible(false);
                        this.scheduleRecommendTrack();
                        runInAction(function () {
                            _this.fetchingState.saving = false;
                        });
                        _a = this.procareDetail, LocationId = _a.LocationId, Id = _a.Id, Client = _a.Client, StatusId = _a.StatusId;
                        logData = {
                            isRecommendationSlot: isRecommendationSlot,
                            locationId: LocationId,
                            ProjectID: Id,
                            ProCareStatusId: StatusId,
                            clientId: Client.Id,
                            TimeofSlot_Rank: timeofSlotRank
                        };
                        code = this.showReschedule
                            ? ClientUserTrackingCode.RspProCareReschedule
                            : ClientUserTrackingCode.RspProCareSchedule;
                        resolve({ code: code, logData: logData });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    __decorate([
        observable
    ], ProcareStore.prototype, "fetchingState", void 0);
    __decorate([
        observable
    ], ProcareStore.prototype, "formData", void 0);
    __decorate([
        action
    ], ProcareStore.prototype, "changeScheduleStartTime", void 0);
    __decorate([
        action
    ], ProcareStore.prototype, "changeScheduleEndTime", void 0);
    __decorate([
        observable
    ], ProcareStore.prototype, "procareDetail", void 0);
    __decorate([
        computed
    ], ProcareStore.prototype, "procareDueDate", null);
    __decorate([
        computed
    ], ProcareStore.prototype, "dueRangeLeft", null);
    __decorate([
        computed
    ], ProcareStore.prototype, "dueRangeRight", null);
    __decorate([
        observable
    ], ProcareStore.prototype, "canChangeTechnician", void 0);
    __decorate([
        observable
    ], ProcareStore.prototype, "hasProcareProject", void 0);
    __decorate([
        action
    ], ProcareStore.prototype, "getProCareDetail", void 0);
    __decorate([
        observable
    ], ProcareStore.prototype, "workOrderList", void 0);
    __decorate([
        observable
    ], ProcareStore.prototype, "totalCount", void 0);
    __decorate([
        observable
    ], ProcareStore.prototype, "isAllWorkOrderListReady", void 0);
    __decorate([
        observable
    ], ProcareStore.prototype, "allWorkOrderList", void 0);
    __decorate([
        action
    ], ProcareStore.prototype, "getProjectWorkOrderList", null);
    __decorate([
        action
    ], ProcareStore.prototype, "getCanChangeTechnician", null);
    __decorate([
        observable
    ], ProcareStore.prototype, "scheduleTime", void 0);
    __decorate([
        observable
    ], ProcareStore.prototype, "isLastVersionAutoSchedule", void 0);
    __decorate([
        observable
    ], ProcareStore.prototype, "scheduleTrackData", void 0);
    __decorate([
        computed
    ], ProcareStore.prototype, "noScheduleTime", null);
    __decorate([
        action
    ], ProcareStore.prototype, "getScheduleTime", null);
    __decorate([
        action.bound
    ], ProcareStore.prototype, "getisLastVersionAutoSchedule", null);
    __decorate([
        action
    ], ProcareStore.prototype, "getAutoScheduleData", null);
    __decorate([
        observable
    ], ProcareStore.prototype, "weatherForecastByTime", void 0);
    __decorate([
        action
    ], ProcareStore.prototype, "getWeatherForecastByTime", null);
    __decorate([
        computed
    ], ProcareStore.prototype, "topItems", null);
    __decorate([
        observable
    ], ProcareStore.prototype, "selectedScheduleTime", void 0);
    __decorate([
        action
    ], ProcareStore.prototype, "selectPeroid", void 0);
    __decorate([
        observable
    ], ProcareStore.prototype, "modalVisible", void 0);
    __decorate([
        action
    ], ProcareStore.prototype, "setModalVisible", void 0);
    __decorate([
        computed
    ], ProcareStore.prototype, "showReschedule", null);
    __decorate([
        computed
    ], ProcareStore.prototype, "showSchedule", null);
    __decorate([
        computed
    ], ProcareStore.prototype, "canSave", null);
    __decorate([
        action
    ], ProcareStore.prototype, "pageMore", void 0);
    __decorate([
        action
    ], ProcareStore.prototype, "getAllSubtask", void 0);
    __decorate([
        action
    ], ProcareStore.prototype, "scheduleRecommendTrack", void 0);
    __decorate([
        action
    ], ProcareStore.prototype, "onLeave", void 0);
    return ProcareStore;
}());
export default ProcareStore;
